/* eslint-disable react-hooks/exhaustive-deps */

import { useLocation } from "react-router-dom";
import { LoadingIcon } from "utils/constant";
import SingleAppealForRegional from "./SingleAppealForRegional";
import SingleAppealForZonal from "./SingleAppealForZonal";

export default function SingleAppeal() {
  const { state } = useLocation();

  if (!state)
    return (
      <div className="flex justify-center items-center h-96">{LoadingIcon}</div>
    );

  return state?.is_regional ? (
    <SingleAppealForRegional />
  ) : (
    <SingleAppealForZonal />
  );
}
